module.exports = __webpack_public_path__ + "img/b2.3f4b5d3e.png";